import { render, staticRenderFns } from "./category-wizard.vue?vue&type=template&id=0c278ddc&scoped=true&"
import script from "./category-wizard.vue?vue&type=script&lang=ts&"
export * from "./category-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./category-wizard.vue?vue&type=style&index=0&id=0c278ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c278ddc",
  null
  
)

export default component.exports